import React, { useState, useEffect } from 'react';
import { Stack, Checkbox, FormControlLabel, Alert } from '@mui/material';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';
import CalendarDateField from '../../../../../platform/util/CalendarDateField';
import { parseCivil } from '../../../../../platform/util/calendarSystem';

export default function DateRangeView({ isDisabled, start, setStart, end, setEnd, userTimeZone = 'UTC', calendarSystem = 'gregory', onValidityChange }) {
  const [indefinite, setIndefinite] = useState(!end);
  const [startValid, setStartValid] = useState(true);
  const [endValid, setEndValid] = useState(true);
  const civil = value => { try { return value ? formatInTimeZone(new Date(value), userTimeZone, 'yyyy-MM-dd') : ''; } catch { return ''; } };
  const first = civil(start), last = civil(end);
  const validRange = Boolean(first && (indefinite || (last && last >= first)) && startValid && (indefinite || endValid));
  useEffect(() => { onValidityChange?.(validRange); }, [validRange, onValidityChange]);
  function change(value, setter, validity) {
    if (!value) { setter(null); validity(false); return; }
    try { parseCivil(value); setter(zonedTimeToUtc(`${value}T00:00:00`, userTimeZone).toISOString()); validity(true); }
    catch { validity(false); }
  }
  return <Stack spacing={2}>
    <CalendarDateField label="Start date" value={first} onChange={date => change(date, setStart, setStartValid)} calendar={calendarSystem} disabled={isDisabled} onValidityChange={setStartValid} />
    <FormControlLabel control={<Checkbox checked={indefinite} disabled={isDisabled} onChange={event => { setIndefinite(event.target.checked); if (event.target.checked) setEnd(null); }} />} label="No end date" />
    {!indefinite && <CalendarDateField label="End date" value={last} onChange={date => change(date, setEnd, setEndValid)} calendar={calendarSystem} disabled={isDisabled} onValidityChange={setEndValid} />}
    {!validRange && <Alert severity="warning">Enter valid dates. The end date must be on or after the start date.</Alert>}
  </Stack>;
}
